// @flow

import React from "react";
import ReactDOM from "react-dom";

import QuickSearch from "../components/Quicksearch";

const els = document.querySelectorAll(".quicksearch");

els.forEach((el: HTMLElement) => {
    const standalone = el.getAttribute("data-standalone") || "";
    const searchTerm = el.getAttribute("data-search-term") || "";
    const action = el.getAttribute("data-action") || "";
    const parameter = el.getAttribute("data-parameter") || "";

    ReactDOM.render(
        <QuickSearch
            standalone={standalone ? JSON.parse(standalone) : false}
            searchTerm={searchTerm}
            action={action}
            parameter={parameter}
        />,
        el
    );
});
